import React, { useCallback, useState } from "react";
import { Button, IconButton, Popover } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { EllipsisIcon } from "../../../../../../../assets/icons";
import { AddEditSharedWithUser } from "../AddEditSharedWithUser/AddEditSharedWithUser";
import { ShareWithLegalEntitySIDTO } from "../../../../../../../models/share-with-legal-entity-si";
import { CompanyLegalEntityRef } from "../../../../../../../models/company-accounts/company-legal-entities";
import { LegalEntitySIDTO } from "../../../../../../../models/legal-entity-si";

interface Props {
  item: ShareWithLegalEntitySIDTO;
  defaultLegalEntity?: CompanyLegalEntityRef | null;
  legalEntitySI: LegalEntitySIDTO;
  handleUpdate: (action: "add" | "edit" | "remove", item: ShareWithLegalEntitySIDTO) => void;
}
interface State {
  open: boolean;
  anchorEl: HTMLButtonElement | null;
}
const ActionsWrapper = ({ item, defaultLegalEntity, legalEntitySI, handleUpdate }: Props) => {
  const theme = useTheme();

  const [state, setState] = useState<State>({
    open: false,
    anchorEl: null,
  });

  const handleChange = useCallback((action: "edit" | "remove", item: ShareWithLegalEntitySIDTO) => {
    setState((state) => ({ ...state, open: false, anchorEl: null }));

    handleUpdate(action, item);
  }, []);

  return (
    <>
      <IconButton
        onClick={(event) => {
          setState((state) => ({
            ...state,
            open: true,
            anchorEl: event.currentTarget as HTMLButtonElement,
          }));
        }}
        style={{
          color: theme.palette.text.primary,
        }}
      >
        <EllipsisIcon />
      </IconButton>
      <Popover
        open={state.open}
        anchorEl={state.anchorEl}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        onClose={() => {
          setState((state) => ({ ...state, open: false, anchorEl: null }));
        }}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            alignItems: "flex-start",
            gap: "5px",
          },
        }}
      >
        <AddEditSharedWithUser
          effect={"edit"}
          item={item}
          handleNotifyParent={(item: ShareWithLegalEntitySIDTO) => handleChange("edit", item)}
          defaultLegalEntity={defaultLegalEntity}
          legalEntitySI={legalEntitySI}
          buttonVariant="text"
        />

        <Button
          onClick={() => handleChange("remove", item)}
          sx={{ textTransform: "none", color: theme.palette.error.main }}
        >
          Remove
        </Button>
      </Popover>
    </>
  );
};

export default ActionsWrapper;
